import { render, staticRenderFns } from "./Applicants.vue?vue&type=template&id=5f0d44b2&scoped=true"
import script from "./Applicants.vue?vue&type=script&lang=js"
export * from "./Applicants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0d44b2",
  null
  
)

export default component.exports